import React from 'react';
import { ColumnConfig } from '../../config';

interface ClientColumnProps {
  column: string;
  config: ColumnConfig;
  row: any;
}

const ClientColumn: React.FC<ClientColumnProps> = ({
  column,
  row
}) => {
  const renderDisplayValue = () => {
    if (column === 'company_name') {
      return <span title={row.original.company_name}>{row.original.company_name}</span>;
    }

    if (column === 'location') {
      const { city, state } = row.original;
      if (city && state) return `${city}, ${state}`;
      if (city) return city;
      if (state) return state;
      return '—';
    }

    if (column === 'contact_count') {
      const count = row.original.contact_count;
      return count === 0 ? '—' : count.toString();
    }

    if (column === 'created_at') {
      return new Date(row.original.created_at).toLocaleDateString();
    }

    return row.original[column] || '';
  };

  return (
    <div className="client-column-display">
      {renderDisplayValue()}
    </div>
  );
};

export default ClientColumn;
